import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField';
import styles from './CollectionModal.scss';

export const CollectionModal = ({
  isOpen,
  onSave,
  onCancel,
  onClose,
  titleInput,
  setTitleInput,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      disableBackdropClick
      disableEscapeKeyDown
      classes={{ paper: styles.dialog_root }}
    >
      <CloseIcon
        style={{
          cursor: 'pointer',
          position: 'absolute',
          right: 10,
          top: 10,
          fontSize: 14,
        }}
        onClick={() => {
          onCancel();
        }}
      />
      <DialogTitle>
        <span className={styles.dialog_header}>Create new collection</span>
      </DialogTitle>
      <div className={styles.dialog_content}>
        <div className={styles.input_item_title}>* Collection name</div>
        <div style={{ marginBottom: 10 }}>
          This is how the collection title will appear on the app
        </div>
        <TextField
          variant="outlined"
          InputProps={{
            classes: {
              root: styles.root_input,
              input: styles.text_input,
            },
          }}
          id="file-name"
          style={{ width: '100%' }}
          onChange={e => {
            setTitleInput(e.target.value);
          }}
          value={titleInput}
        />
      </div>

      <DialogActions style={{ marginRight: 20, marginTop: 80 }}>
        <Button onClick={onCancel} variant="text" color="default">
          <span className={styles.button}>Cancel</span>
        </Button>
        <Button
          onClick={onSave}
          color="primary"
          variant="contained"
          disabled={!titleInput.trim()}
          style={{ fontSize: 14 }}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CollectionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  titleInput: PropTypes.string,
  setTitleInput: PropTypes.func,
};
